import { IStyleState } from './styleContext';
import { StyleActionsTypes, TStyleAction } from './styleActions';

export const styleReducer = (state: IStyleState, action: TStyleAction): IStyleState => {
	switch (action.type) {
		case StyleActionsTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
			};
		case StyleActionsTypes.SET_ALL_DATA:
			return {
				...state,
				styleSettingColors: action.payload.styleSettingColors,
				mediaSettingsForUpdate: action.payload.mediaSettingsForUpdate,
				documentSettingsForUpdate: action.payload.documentSettingsForUpdate,
			};
		case StyleActionsTypes.SET_STYLE_SETTINGS:
			return {
				...state,
				styleSettings: action.payload.styleSettings,
			};
		case StyleActionsTypes.SET_MEDIA_SETTINGS:
			return {
				...state,
				mediaSettingsForUpdate: action.payload.mediaSettingsForUpdate,
			};
		case StyleActionsTypes.SET_GROUP:
			return {
				...state,
				selectedGroup: action.payload.group,
			};
		case StyleActionsTypes.SET_LANGUAGE:
			return {
				...state,
				selectedLanguage: action.payload.language,
			};
		case StyleActionsTypes.ADD_GROUP_FOR_LOADER:
			return {
				...state,
				groupsForLoader: action.payload.updatedLoaders,
			};
		case StyleActionsTypes.REMOVE_GROUP_FOR_LOADER:
			return {
				...state,
				groupsForLoader: action.payload.updatedLoaders,
			};
		case StyleActionsTypes.CHANGE_DOCUMENT_SETTINGS_FOR_UPDATE:
			return {
				...state,
				documentSettingsForUpdate: action.payload.documentSettingsForUpdate,
			};
		case StyleActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
